import React from 'react';
import { Crown } from 'lucide-react';
export function SectionDivider() {
  return <div className="w-full flex items-center justify-center py-12 opacity-40" data-id="element-239">
      <div className="h-[1px] w-24 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-240"></div>
      <Crown className="w-5 h-5 text-gold-500 mx-4" data-id="element-241" />
      <div className="h-[1px] w-24 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-242"></div>
    </div>;
}